import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';
import type { DesignStore, StoreSnapshot } from './design-store';

const StoreContext = createContext<DesignStore | null>(null);

export function DesignStoreProvider({
  store,
  children,
}: {
  store: DesignStore;
  children: ReactNode;
}) {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export function useDesignStore(): DesignStore {
  const store = useContext(StoreContext);
  if (!store) throw new Error('DesignStoreProvider is missing');
  return store;
}

export function useDesignSnapshot(): StoreSnapshot {
  const store = useDesignStore();
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
